import React, { useState } from 'react';

/**
 * PasswordInput - A reusable password input with show/hide toggle.
 */
const PasswordInput = ({
    id,
    name,
    value,
    onChange,
    placeholder = 'Your Password',
    className = 'form-control input-filed',
    ...rest
}) => {
    const [show, setShow] = useState(false);

    return (
        <div className="position-relative">
            <input
                {...rest}
                type={show ? 'text' : 'password'}
                className={className}
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                style={{ paddingRight: '44px' }}
            />
            <button
                type="button"
                onClick={() => setShow((prev) => !prev)}
                className="btn p-0 position-absolute d-flex align-items-center justify-content-center"
                style={{
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#667085',
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                    zIndex: 5,
                }}
                tabIndex={-1}
                aria-label={show ? 'Hide password' : 'Show password'}
            >
                {show ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10.73 10.73A3 3 0 0 0 14.27 14.27" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                )}
            </button>
        </div>
    );
};

export default PasswordInput;
